<template>
    <div style="width: 100%;">
        <div class="d-flex col-12">
            <div class="form-control-label" style="white-space: pre-line;margin-left: 4px;"><span v-if="question.is_required" class="required-star mr-1">*</span>{{title}}</div>
        </div>
        <div class="col-12" v-if="question.image_file_name">
            <img class="cursor-pointer" :src="this.context.storageEndpoint + this.question.image_file_name" @click="openPhotoViewer = true"/>
        </div>
        <div class="col-12"><p class="text-muted px-1 question-description" v-html="formattedText"></p></div>
        <div v-if="!hasValidAnswer && showInvalid"
            class="col-12 pl-3">
            <div class="alert alert-warning">{{$t('message.please_fill_your_answer')}}</div>
        </div>
        <p class="col-12 picker-container">
            <date-time-picker
                ref="picker"
                v-model="date"
                :lang="context.lang"
                :themeColor='provider.theme_tint_hex'
                :no-icon="true"
                :placeholder="$t('please_select_date')"
                inputClass="form-control text-left"
                :timesForDate="() => {}"
                :showDateTextOnly="true"
                fixedTime="00:00">
            </date-time-picker>
        </p>
        <photo-viewer
            v-if="openPhotoViewer"
            ref="photoViewer"
            :photos="photo"
            :context="context"
            @close="openPhotoViewer = false"></photo-viewer>
    </div>
</template>

<i18n>
{
    "en": {
        "please_select_date": "Please Select Date"
    },
    "zh": {
        "please_select_date": "請選擇日期"
    }
}
</i18n>

<script>
import Constants from '../../constants';
import moment from 'moment';
import DateTimePicker from '../common/DateTimePicker';
import PhotoViewer from '../common/PhotoViewer.vue';

export default {
    components: { DateTimePicker, PhotoViewer },
    props: ['question', 'provider', 'context', 'answer'],
    data() {
        var selectedDate = null;
        var dateString = '';
        if (this.answer && this.answer.content) {
            let content = JSON.parse(this.answer.content);
            if (content.date) {
                selectedDate = moment(content.date);
                dateString = selectedDate.format('YYYY-MM-DD');
            }
        }

        return {
            id: this.question.id,
            content: this.question.content,
            status: this.question.status,
            adminQuestion: this.question.question,
            Constants,
            date: dateString,
            showInvalid: false,
            todayMoment: moment(),
            selectedDate: selectedDate,
            openPhotoViewer: false
        };
    },

    watch: {
        date() {
            this.selectedDate = moment.tz(this.date, this.provider.timezone);
        }
    },

    computed: {
        title: function() {
            return this.content.meta.title || '';
        },

        photo() {
            if (this.question.image_file_name) {
                return [{
                    path: this.question.image_file_name
                }];
            } else {
                return [];
            }
        },

        hasAnswer() {
            return !!this.selectedDate;
        },

        hasValidAnswer() {
            return this.selectedDate;
        },
        formattedText() {
            const text = this.content.data.text;
            return text.nl2brIfNotHTML();
        }
    },

    methods: {
        highlightInvalidState() {
            this.showInvalid = true;
        },

        getDataToPersist() {
            return {
                question_id: this.id,
                answer: {
                    date: this.selectedDate ? this.selectedDate.format('YYYY-MM-DD') : ''
                },
                answer_id: this.answer ? this.answer.id : null
            };
        }
    }
}
</script>

<style scoped>

::-webkit-calendar-picker-indicator {
    filter: invert(0.5);
}

.required-star {
    color: red;
    font-weight: bold;
}

textarea {
    margin: 1em auto;
    width: 96%;
}

.answer-outer-wrapper {
    min-width: 30%;
    background: #EEE;
    border-radius: 4px;
    padding: 1em;
    cursor: pointer;
}

img {
    max-width: max-content;
    width: 100%;
    border-radius: 4px;
}

.picker-container >>> .placeholder {
    justify-content: flex-start;
    padding-left: 12px;
    color: #aaa;
}

.picker-container >>> .form-control {
    padding: 12px;
    background: #eee;
}

</style>
